import constructSizeForm from 'utils/constructSizeForm'

export default function setSizeOnOrderItem({ state, props }) {
  const { orderItemId } = props
  const basketItem = state.get(`basket.basketItems.${orderItemId}`)
  const unit = state.get('basket.unit')

  const { target, ratio } = basketItem

  state.set(
    `basket.basketItems.${orderItemId}.form`,
    constructSizeForm(unit, ratio, target)
  )
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/setSizeOnOrderItem.js